import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { useLang } from '../context/LangContext';

export const ImpactStats = () => {
  const { t } = useLang();
  const [s, setS] = useState(null);
  useEffect(() => { api.get('/stats/public').then(({ data }) => setS(data)).catch(() => {}); }, []);
  if (!s) return null;
  const items = [
    [s.checks_run, t('benefit checks run')],
    [s.applications_tracked, t('applications tracked')],
    [s.applications_submitted, t('applications submitted')],
    [s.partner_handoffs, t('partner handoffs')],
    [s.programs_covered, t('programs covered')],
  ];
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 pb-12" data-testid="impact-stats" aria-label="Community impact">
      <div className="rounded-2xl border border-border bg-card p-6 grid grid-cols-2 sm:grid-cols-5 gap-4">
        {items.map(([n, l]) => (
          <div key={l} data-testid={`stat-${l.replace(/\s+/g, '-')}`}>
            <div className="text-3xl font-bold text-primary" style={{fontFamily: 'Lexend'}}>{n.toLocaleString()}</div>
            <div className="text-xs text-muted-foreground mt-0.5">{l}</div>
          </div>
        ))}
      </div>
      <p className="text-xs text-muted-foreground mt-2">{t('Anonymous totals across everyone using AccessBenefits Ontario. No personal data is shown.')}</p>
    </section>
  );
};
